import styled from "styled-components";

export const StyledGarbageImg = styled.img`
	width: 20px;
	position: absolute;
`;
